import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext"
import { dateConvert } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from "xlsx";
import { MultiSelect } from "primereact/multiselect";
import { useReactToPrint } from "react-to-print";
import { useInventoryAssetForm } from "./useInventoryAssetForm";

export const useManageAssets = () => {

    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const tagRef = useRef(null);
    const [display, setDisplay] = useState({ add: false, assign: false, receive: false, history: false, media: false });
    const [dropdownOpts, setDropdownOpts] = useState({ asset_status: [], branch: [], asset_make: [], asset_type: [], vendor: [], cpu_in_gen_ghz: [], ssid: [], os: [], asset_attributes_type: [], assets_details: [], locations: [], purchase_type: [{ label: "Purchased", flag: false }, { label: "Rental", flag: true },] })
    const [filterValues, setFilterValues] = useState({ asset_status: [], locations: [], branch: [], asset_make: [], date: null, asset_type: {}, purchase_type: { label: "Purchased", flag: false }, view_default: false, show_order_popup: false, order_api_called: false, user_location: {} });
    const [isChange, setIsChange] = useState(false);
    const gridRef = useRef(null);
    const [editData, setEditData] = useState({});
    const [popupData, setPopupData] = useState({ media: [] });
    const [loader, setLoader] = useState({ data_grid: false, order_grid: false });
    const [allRowData, setAllRowData] = useState([]);
    const [rowData, setRowData] = useState(allRowData);
    const basicColDef = [
        {
            field: "srno",
            headerName: "S.No",
            display_order: -1,
            pinned: "left"
        },
        {
            field: "actions",
            display_order: 0,
            headerName: "Action",
            width: 170,
            sortable: false,
            filter: false,
            autoHeight: true,
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div className="pt-2" style={{ height: "100%" }}>
                        <div className="d-flex justify-content-center align-items-center gap-2" >
                            <div className={`inventory-icon ${params?.data?.location_name !== filterValues?.user_location ? "disabled c-not-allowed" : "border border-dark c-pointer"} d-flex justify-content-center align-items-center rounded`} style={{ height: "20px", width: "20px", padding: "0.7rem" }} onClick={() => { if (params?.data?.location_name === filterValues?.user_location) { setEditData(params?.data); setDisplay((prev) => ({ ...prev, add: true })); } }} title="Edit Asset">
                                <FontAwesomeIcon icon="fa-solid fa-pencil" />
                            </div>
                            <div className={`inventory-icon ${params?.data?.location_name !== filterValues?.user_location ? "disabled c-not-allowed" : "border border-success text-success c-pointer"} d-flex justify-content-center align-items-center rounded`} style={{ height: "20px", width: "20px", padding: "0.7rem" }} onClick={() => { if (params?.data?.location_name === filterValues?.user_location) { setEditData(params?.data); setDisplay((prev) => ({ ...prev, assign: true })); } }} title="Assign Asset">
                                <FontAwesomeIcon icon="fa-solid fa-user-plus" />
                            </div>
                            <div className={`inventory-icon ${(_.isEmpty(params?.data?.is_currently_assigned) || params?.data?.location_name !== filterValues?.user_location) ? "disabled c-not-allowed" : "border border-danger text-danger c-pointer"} d-flex justify-content-center align-items-center rounded`} style={{ height: "20px", width: "20px", padding: "0.7rem" }} title="Receive Asset" onClick={() => { if (!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.location_name === filterValues?.user_location) { setEditData(params?.data); setDisplay((prev) => ({ ...prev, receive: true })); } }}>
                                <FontAwesomeIcon icon="fa-solid fa-rotate-right" />
                            </div>
                            <div className={`inventory-icon ${(params?.data?.assigned_history?.length === 0 || params?.data?.location_name !== filterValues?.user_location) ? "disabled c-not-allowed" : "border border-primary text-primary c-pointer"} d-flex justify-content-center align-items-center rounded`} style={{ height: "20px", width: "20px", padding: "0.7rem" }} title="Asset History" onClick={() => { if (params?.data?.assigned_history?.length > 0 && params?.data?.location_name === filterValues?.user_location) { setEditData(params?.data); setDisplay((prev) => ({ ...prev, history: true })); } }}>
                                {params?.data?.assigned_history?.length}
                            </div>
                            <div className={`inventory-icon ${(_.isEmpty(params?.data?.is_currently_assigned) || params?.data?.location_name !== filterValues?.user_location) ? "disabled c-not-allowed" : "border border-warning text-warning c-pointer"} d-flex justify-content-center align-items-center rounded`} style={{ height: "20px", width: "20px", padding: "0.7rem" }} onClick={() => { if (!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.location_name === filterValues?.user_location) { handleStickerData(params?.data); } }} title="Download Sticker">
                                <FontAwesomeIcon icon="fa-solid fa-print" />
                            </div>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "asset_unique_id",
            display_order: 1,
            headerName: "Asset Unique Id",
            pinned: "left",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "status_name",
            display_order: 2,
            headerName: "Status",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "asset_type_name",
            display_order: 3,
            headerName: "Asset Type",
            hide: true,
            excelDownload: true,
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "asset_make_name",
            display_order: 4,
            headerName: "Make",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "model_number",
            display_order: 5,
            headerName: "Model",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "machine_host_name",
            display_order: 9,
            headerName: "Computer Name",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" }
        },
        {
            field: "finance_unique_id",
            display_order: 10,
            headerName: "Finance Unique Id",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" }
        },
        {
            field: "employment_type",
            display_order: 12,
            headerName: "Category",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.is_currently_assigned?.employment_type}
                    </div>
                )
            }
        },
        {
            field: "employee_id",
            display_order: 13,
            headerName: "Employee ID",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.is_currently_assigned?.employee_id}
                    </div>
                )
            }
        },
        {
            field: "enterprise_id",
            display_order: 14,
            headerName: "Enterprise ID",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.is_currently_assigned?.enterprise_id}
                    </div>
                )
            }
        },
        {
            field: "user_display_name",
            display_order: 15,
            headerName: "Employee Name",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.is_currently_assigned?.user_display_name}
                    </div>
                )
            }
        },
        {
            field: "email_id",
            display_order: 16,
            headerName: "Email Id",
            headerClass: "header-wrap",
            cellRenderer: (params) => {
                return (
                    <div className="w100">
                        {!_.isEmpty(params?.data?.is_currently_assigned) && <div title={params?.data?.is_currently_assigned?.email_id} className="w100 text-truncate">{params?.data?.is_currently_assigned?.email_id}</div>}
                    </div>
                )
            }
        },
        {
            field: "manager_name",
            display_order: 17,
            headerName: "Manager Name",
            headerClass: "header-wrap",
            cellRenderer: (params) => {
                return (
                    <div className="w100">
                        {!_.isEmpty(params?.data?.is_currently_assigned) && <div title={params?.data?.is_currently_assigned?.manager_name} className="w100 text-truncate">{params?.data?.is_currently_assigned?.manager_name}</div>}
                    </div>
                )
            }
        },
        {
            field: "assigned_date",
            display_order: 18,
            headerName: "Assign Date",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && dateConvert(params?.data?.is_currently_assigned?.assigned_date, "day-month-year")}
                    </div>
                )
            }
        },
        {
            field: "business_unit",
            display_order: 21,
            headerName: "BU",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="w100 text-truncate">{params?.data?.business_units}</div>
                )
            }
        },
        {
            field: "sub_business_unit",
            display_order: 22,
            headerName: "SUB BU",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="w100 text-truncate">{params?.data?.sub_business_units}</div>
                )
            }
        },
        {
            field: "contact_number",
            display_order: 23,
            headerName: "Contact Details",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!_.isEmpty(params?.data?.is_currently_assigned) && params?.data?.is_currently_assigned?.contact_number}
                    </div>
                )
            }
        },
        {
            field: "serial_number",
            display_order: 24,
            headerName: "Serial Number",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "location_name",
            display_order: 25,
            headerName: "Location",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "branch_name",
            display_order: 26,
            headerName: "Branch",
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="w100 text-truncate">{params?.value}</div>
                )
            }
        },
        {
            field: "vendor_name",
            display_order: 31,
            headerName: "Vendor",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "invoice_number",
            display_order: 32,
            headerName: "Invoice No.",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "purchase_price",
            display_order: 33,
            headerName: filterValues?.purchase_type?.flag ? "Rental Cost" : "Cost",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "purchase_date",
            display_order: 34,
            headerName: filterValues?.purchase_type?.flag ? "Rental Date" : "Purchase Date",
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-month-year")}</div>
                )
            }
        },
        {
            field: "warranty_end_date",
            display_order: 35,
            headerName: "Warranty End",
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-month-year")}</div>
                )
            }
        },
        {
            field: "insured_by",
            display_order: 36,
            headerName: "Insured By",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "chargeback_to",
            display_order: 37,
            headerName: "Chargeback To",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="w100 text-truncate">{params?.value}</div>
                )
            }
        },
        {
            field: "used_year",
            display_order: 38,
            headerName: "Used Year",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "depreciation_percentage",
            display_order: 39,
            headerName: "Depreciation Percentage",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" },
        },
        {
            field: "depreciation_cost",
            display_order: 40,
            headerName: "Depreciation Cost",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" },
        },
        {
            field: "current_cost",
            display_order: 41,
            headerName: "Current Cost",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" },
        },
        {
            field: "life_in_months",
            display_order: 42,
            headerName: "Life (mo)",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "used_month",
            display_order: 43,
            headerName: "Asset Used Months",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "asset_life",
            display_order: 44,
            headerName: "Asset Life",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" }
        },
        {
            field: "remark",
            display_order: 45,
            headerName: "Remarks",
            cellStyle: { alignContent: "center" },
            tooltipValueGetter: (params) => params?.value ? params?.value : "",
        },
        {
            field: "assigned_history",
            display_order: 47,
            headerName: "Assigned History",
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.value?.length > 0 ? "text-primary c-pointer" : "text-secondary"} onClick={() => { if (params?.value?.length > 0) { setEditData(params?.data); setDisplay((prev) => ({ ...prev, history: true })); } }}>
                        {params?.value?.length || 0} records
                    </div>
                )
            }
        },
        {
            field: "media",
            display_order: 48,
            headerName: "Media",
            cellStyle: { textAlign: "center", alignContent: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.value?.length > 0 ? "text-primary c-pointer" : "text-secondary"} onClick={() => { if (params?.value?.length > 0) { setDisplay((prev) => ({ ...prev, media: true })); setPopupData((prev) => ({ ...prev, media: _.pluck(params?.value, "media_obj") || [{ file: "" }] })) } }}>
                        {params?.value?.length || 0} files
                    </div>
                )
            }
        },
    ]
    const [defaultDynColDef, setDefaultDynColDef] = useState(null);
    const [columnDef, setColumnDef] = useState(defaultDynColDef);
    const [apiCustomCols, setApiCustomCols] = useState([]);
    const customColRef = useRef(null);
    const orderColumnDef = [
        {
            field: "column_display_name",
            headerName: "Column Name",
            flex: 1,
            cellRenderer: (params) => {
                const value = _.findWhere(columnDef, { field: params?.data?.column_display_name?.includes("ssid") ? "ssid" : params?.data?.column_display_name }) || _.findWhere(columnDef, { optionalField: params?.data?.column_display_name })
                return (
                    <div>{value?.headerName}</div>
                )
            }
        },
        {
            field: "column_display_id",
            headerName: "Display Order",
            flex: 0.5,
            cellRenderer: (params) => {
                return (
                    <div>
                        <input type="number" className="w100" value={params?.data?.column_display_id} onChange={(e) => handleChangeColumnOrder(params, e)} onBlur={() => saveOrderChange(params?.data)} />
                    </div>
                )
            }
        }
    ];
    const [orderRowData, setOrderRowData] = useState({ data: [], api_data: [] })
    const [search, setSearch] = useState("");
    const [scrollTop, setScrollTop] = useState(0);
    const [pagination, setPagination] = useState({ visible: true, view_all: false, total_records: 0, total_pages: 0, current_page: 1, display_page_out_of_total: "" });
    const [importExcel, setImportExcel] = useState({ visible: false, data: [] });
    const [columns, setColumns] = useState([]);
    const [stickerData, setStickerData] = useState({ data: null, barcode_data: null });
    const contentRef = useRef(null);
    const [config, setConfig] = useState({ visible: false, loader: false, data: [], currentConfig: [], is_change: false });
    const configCols = [
        { key: "asset_type_name", label: "Asset Type", style: { width: "200px" } },
        {
            key: "config", label: "Dynamic Columns", style: { width: "750px", maxWidth: "79%" },
            render: (row) => {
                return (
                    <div className="w100">
                        <MultiSelect options={dropdownOpts?.asset_attributes_type || []} value={row?.saved_columns || []} display="chip" optionLabel="attribute_type_name" style={{ height: "38px" }} onChange={(e) => { handleColumnChange(e.target?.value, row, false) }} filter filterInputAutoFocus onHide={() => { if (config?.is_change) { saveAssetConfiguration(row); } }} className="sk-multiselect" onRemove={(e) => { handleColumnChange(e?.value, row, true) }} />
                    </div>
                )
            }
        },
    ]
    const { validateUniqueId } = useInventoryAssetForm({ onClose: () => { }, editData: editData, dropdownOpts: dropdownOpts, columnConfig: config?.data, selectedAssetType: filterValues?.asset_type, handleAssetDetails: () => { handleAssetDetails() } });

    useEffect(() => {
        sessionStorage.removeItem("asset_status");
        sessionStorage.removeItem("asset_make");
        sessionStorage.removeItem("branch");
        sessionStorage.removeItem("asset_type");
        sessionStorage.removeItem("vendor");
        sessionStorage.removeItem("cpu_in_gen_ghz");
        sessionStorage.removeItem("ssid");
        sessionStorage.removeItem("os");
        sessionStorage.removeItem("asset_attributes_type");
        sessionStorage.removeItem("assets_details");
        sessionStorage.removeItem("locations");
        callautopopulate("user_info", "users", "asset_status", "asset_make", "branch", "asset_type", "vendor", "cpu_in_gen_ghz", "ssid", "os", "asset_attributes_type", "assets_details", "locations").then((res) => {
            setDropdownOpts((prev) => ({
                ...prev,
                status: res?.asset_status,
                branch: res?.branch,
                asset_make: res?.asset_make,
                asset_type: res?.asset_type,
                vendor: res?.vendor,
                cpu_in_gen_ghz: res?.cpu_in_gen_ghz,
                ssid: res?.ssid,
                os: res?.os,
                asset_attributes_type: res?.asset_attributes_type,
                assets_details: res?.assets_details,
                locations: _.sortBy(_.filter(res?.locations, loc => loc?.location), "location")
            }));
            const userLocation = _.findWhere(res?.users, { user_code: res?.user_info?.[0]?.user_code })?.location_name;
            const loc = _.findWhere(_.filter(res?.locations, loc => loc?.location), { location: userLocation });
            setFilterValues((prev) => ({ ...prev, asset_type: res?.asset_type?.[0], locations: loc ? [loc] : [], user_location: userLocation }));
        })
    }, [])

    useEffect(() => {
        (!_.isEmpty(dropdownOpts?.asset_type) && !_.isEmpty(dropdownOpts?.asset_attributes_type)) && getAssetConfiguration();
    }, [dropdownOpts?.asset_type, dropdownOpts?.asset_attributes_type])

    useEffect(() => {
        if (filterValues?.apiCall) {

            setFilterValues((prev) => ({ ...prev, apiCall: false }));
        } else if (!_.isEmpty(defaultDynColDef)) {
            getInventoryDetails();
        }
    }, [filterValues?.date, filterValues?.purchase_type, pagination?.current_page, pagination?.view_all, defaultDynColDef, filterValues.apiCall])






    useEffect(() => {
        if (filterValues?.view_default) {
            setColumnDef(defaultDynColDef);
        } else {
            customColRef.current = apiCustomCols;
            setColumnDef(apiCustomCols);
        }
    }, [filterValues?.view_default, defaultDynColDef])

    useEffect(() => {
        if (search && !_.isEmpty(allRowData)) {
            onFilterTextBoxChanged(search);
        }
    }, [allRowData])

    useEffect(() => {
        // set row data of column order popup
        let cols = []
        orderRowData?.api_data?.forEach(item => {
            if (!_.isEmpty(_.findWhere(config?.currentConfig, { attribute_type_key: item?.column_display_name?.includes("ssid") ? "ssid" : item?.column_display_name })) || !_.isEmpty(_.findWhere(basicColDef, { field: item?.column_display_name })) || !_.isEmpty(_.findWhere(config?.currentConfig, { attribute_type_key: `${item?.column_display_name?.split("_name")?.[0]}` }))) {
                cols?.push(item);
            }
        })
        !_.isEmpty(cols) && setOrderRowData((prev) => ({ ...prev, data: cols }));
    }, [config?.api_data, orderRowData?.api_data])

    useEffect(() => {
        if (!_.isEmpty(config?.api_data) && !_.isEmpty(filterValues?.asset_type)) {
            const current = _.findWhere(config?.api_data, { asset_type_id: filterValues?.asset_type?.asset_type_id })?.saved_columns;
            setConfig((prev) => ({ ...prev, currentConfig: current }));
            setDefaultDynamicCols(current);
        }
    }, [config?.api_data, filterValues?.asset_type])

    useEffect(() => {
        if (_.isObject(stickerData) && !_.isEmpty(stickerData)) {
            reactToPrintFn();
        }
    }, [stickerData]);

    const getInventoryDetails = async (key) => {
        try {
            const viewport = document.querySelector('.ag-body-viewport');
            if (viewport) { setScrollTop(viewport.scrollTop) };

            setAllRowData([]);
            setRowData([]);
            setLoader((prev) => ({ ...prev, data_grid: true }));
            const payload = {
                purchase_date: filterValues?.date ? dateConvert(filterValues?.date, "iso-string") : "",
                asset_make_ids: key === "make" ? "" : _.pluck(filterValues?.asset_make, "asset_make_id")?.toString("") || "",
                asset_status_ids: key === "asset_status" ? "" : _.pluck(filterValues?.asset_status, "status_id")?.toString("") || "",
                locations: key === "locations" ? "" : _.pluck(filterValues?.locations, "location")?.toString() || "",
                branch_ids: key === "branch" ? "" : _.pluck(filterValues?.branch, "branch_id")?.toString("") || "",
                is_rental: filterValues?.purchase_type?.flag,
                page_number: pagination?.current_page > 0 ? pagination?.current_page - 1 : pagination?.current_page,
                is_pagination: !pagination?.view_all || false,
                asset_type_id: filterValues?.asset_type?.asset_type_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETASSETSLISTVIEW"), payload);
            if (res) {
                const data = _.sortBy(res?.body?.data?.assets_details, "asset_unique_id");
                const attributeData = res?.body?.data?.asset_attributes_details;
                const historyData = res?.body?.data?.asset_trans_details;
                const originalMediaData = res?.body?.data?.asset_original_media || [];
                const transMediaData = res?.body?.data?.asset_assign_receive_media || [];
                const columnOrderData = res?.body?.data?.assets_metadata_columns_details || [];
                const paginationData = res?.body?.data?.page_count?.[0];
                const childAssets = res?.body?.data?.asset_mapping
                setPagination((prev) => ({ ...prev, total_records: paginationData?.total_assets, total_pages: paginationData?.paging, display_page_out_of_total: paginationData?.current_records }))

                // dynamic columns ordering
                const customColumns = defaultDynColDef?.map(item => { return { ...item, display_order: item?.field === "srno" ? -1 : (item?.field === "actions" ? 0 : _.findWhere(columnOrderData, { column_display_name: item?.field })?.column_display_id || _.findWhere(columnOrderData, { column_display_name: item?.optionalField })?.column_display_id || Math.max([..._.pluck(defaultDynColDef, "display_order")]) + 1) } }) || [];
                setApiCustomCols([...customColumns]);
                customColRef.current = [...customColumns];
                !filterValues?.view_default && setColumnDef([...customColumns]);
                setOrderRowData((prev) => ({ ...prev, api_data: columnOrderData, data: columnOrderData }));

                data?.map((item, index) => {
                    const childAsset = _.filter(childAssets, { asset_id: item?.asset_id })
                    item["srno"] = index + 1;
                    const attributeArray = _.filter(attributeData, { asset_unique_id: item?.asset_unique_id });
                    const historyArray = _.filter(historyData, { asset_unique_id: item?.asset_unique_id });
                    const originalMediaArray = _.filter(originalMediaData, { asset_id: item?.asset_id });
                    item["attributes"] = attributeArray;
                    item["all_history"] = historyData;
                    item["assigned_history"] = historyArray;
                    item["is_currently_assigned"] = _.filter(historyArray, (item) => item?.asset_trans_type?.trim()?.toLowerCase() === "a")?.[0];

                    item["employment_type"] = item?.is_currently_assigned?.employment_type || "";
                    item["employee_id"] = item?.is_currently_assigned?.employee_id || "";
                    item["enterprise_id"] = item?.is_currently_assigned?.enterprise_id || "";
                    item["user_display_name"] = item?.is_currently_assigned?.user_display_name || "";
                    item["email_id"] = item?.is_currently_assigned?.email_id || "";
                    item["assigned_date"] = item?.is_currently_assigned?.assigned_date || "";
                    item["contact_number"] = item?.is_currently_assigned?.contact_number || "";

                    item["depreciation_percentage"] = item?.depreciation_percentage ? parseFloat(item?.depreciation_percentage?.toFixed(2)) : 0;
                    item["depreciation_cost"] = item?.depreciation_cost ? parseFloat(item?.depreciation_cost?.toFixed(2)) : 0;
                    item["current_cost"] = item?.current_cost ? parseFloat(item?.current_cost?.toFixed(2)) : 0;
                    item["child_assets"] = childAsset
                    item["asset_tran_ids"] = _.pluck(childAsset, "child_trans_ids")
                    // set attribute values to dynamic columns
                    attributeArray?.forEach((att) => {
                        item[att?.attribute_type_name] = att?.attribute_unit_name;
                    })

                    // set media array
                    let mediaArray = [];
                    const media = originalMediaArray;
                    media?.forEach((med) => {
                        mediaArray.push({ details: med, media_obj: { file: med?.asset_unique_file_id, base64: med?.asset_unique_file_id } });
                    })
                    item["media"] = mediaArray;

                    // set assign/receive media array
                    let mediaTransArray = [];
                    const mediaTrans = transMediaData;
                    mediaTrans?.forEach((med) => {
                        mediaTransArray.push({ details: med, media_obj: { file: med?.asset_unique_file_id, base64: med?.asset_unique_file_id } });
                    })
                    item["trans_media"] = mediaTransArray;
                })
                setAllRowData(data);
                setRowData(data);
                setLoader((prev) => ({ ...prev, data_grid: false }));
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
                setTimeout(restoreScroll, 50);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, data_grid: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const onFilterTextBoxChanged = (e) => {
        setSearch(e)
        const val = e?.toLowerCase()?.trim();
        const allRows = [...allRowData] || [];
        if (!val) {
            setRowData(allRows);
            return;
        }

        const isPhraseSearch = val?.includes(" ");

        const filtered = allRows.filter((row) => {
            const text = Object.values(row).join(" ").toLowerCase();
            if (isPhraseSearch) {
                return text.includes(val);
            } else {
                return text.split(/\s+/).some((word) => word.includes(val));
            }
        });

        setRowData(filtered?.map((item, index) => { return { ...item, srno: index + 1 } }));
    };

    const handleExcelDownload = async () => {
        if (_.isEmpty(rowData)) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Inventory List');

        const sortedColumnDef = _.sortBy(columnDef, "display_order");

        const colHeaders = _.filter(sortedColumnDef, (item) => !(item?.headerName === "Action" || item?.headerName === "Assigned History" || item?.headerName === "Media") && (!item?.hide || (item?.hide && item?.excelDownload)));
        const excelHeaders = _.pluck(colHeaders, "headerName");

        const headerRow = worksheet.addRow(excelHeaders);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            cell.font = { color: { argb: 'FFFFFFFF' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF12455D' }
            };
        });

        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        const dataFields = _.pluck(_.filter(sortedColumnDef, (item) => !(item?.field === "actions" || item?.field === "assigned_history" || item?.field === "media") && (!item?.hide || (item?.hide && item?.excelDownload))), "field");
        rowData.forEach(rowdata => {
            let dataArray = [];
            dataFields?.forEach((field) => {
                if ((field === "purchase_date" || field === "warranty_end_date" || field === "discontinued_date") && rowdata[field]) {
                    dataArray.push(dateConvert(rowdata[field], "date-month-year") || "NA");
                } else if (field === "employment_type" || field === "employee_id" || field === "enterprise_id" || field === "user_display_name" || field === "email_id" || field === "contact_number") {
                    dataArray.push(rowdata?.is_currently_assigned?.[field] || "Stock");
                } else if (field === "assigned_date") {
                    dataArray.push(dateConvert(rowdata?.is_currently_assigned?.assigned_date, "date-month-year") || "NA");
                } else if (!_.isEmpty(_.findWhere(dropdownOpts?.asset_attributes_type, { attribute_type_key: field }))) {
                    const attributeTypeId = _.findWhere(dropdownOpts?.asset_attributes_type, { attribute_type_key: field })?.attribute_type_id;
                    const value = _.findWhere(rowdata?.attributes, { attribute_type_id: attributeTypeId })?.attribute_unit_name || "NA"
                    dataArray.push(value || "NA");
                } else {
                    dataArray.push(rowdata[field] || "NA");
                }
            })
            worksheet.addRow(dataArray);
        });

        // set dynamic widths for columns according to its content
        worksheet.columns.forEach((col) => {
            let maxLength = 10;
            col.eachCell({ includeEmpty: true }, (cell) => {
                const cellValue = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, cellValue.length);
            });
            col.width = maxLength + 2;
            col.alignment = { horizontal: "left" };
        });

        // Enable filter on header row
        const columnCount = worksheet.columns.length;
        const lastColumnLetter = worksheet.getColumn(columnCount).letter;

        worksheet.autoFilter = {
            from: 'A1',
            to: `${lastColumnLetter}1`
        };

        const fileName = "Inventory_List.xlsx";

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, fileName);
    };

    const handleChangeColumnOrder = (rowdata, event) => {
        let data = [...orderRowData?.data];
        const updatedData = [...data];
        updatedData[rowdata.node.rowIndex].column_display_id = parseInt(event?.target?.value);
        const rowNode = gridRef.current.api.getDisplayedRowAtIndex(rowdata?.node?.rowIndex);
        rowNode.setData(updatedData[rowdata.node.rowIndex]);
    }

    const saveOrderChange = async (rowdata) => {
        try {
            if (parseInt(rowdata?.column_display_id) === 0) {
                showInfo("Info", "Display order cannot be 0");
                return;
            } else if (parseInt(rowdata?.column_display_id) === parseInt(_.findWhere(customColRef.current, { field: rowdata?.column_display_name })?.display_order)) {
                showInfo("Info", "Display order not updated");
                return;
            }
            const payload = {
                "column_id": rowdata?.column_id || 0,
                "column_display_id": rowdata?.column_display_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTASSETSMETADATACOLUMNS"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                const indexChanged = _.indexOf(customColRef.current, _.findWhere(customColRef.current, { field: rowdata.column_display_name }));
                if (indexChanged !== -1) {
                    customColRef.current[indexChanged] = { ...customColRef.current[indexChanged], display_order: rowdata?.column_display_id };
                    setColumnDef(customColRef.current);
                }
                setFilterValues((prev) => ({ ...prev, order_api_called: true }));
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const getAssetConfiguration = async () => {
        try {
            setConfig((prev) => ({ ...prev, loader: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETASSETCONFIGURATION"), {});
            if (res) {
                const data = res?.body?.data?.asset_configuration_details;
                const children = dropdownOpts?.asset_type?.map(child => {
                    let savedColumns = [];
                    const filteredData = _.filter(data, item => item?.asset_type_id === child?.asset_type_id);
                    filteredData?.forEach(item => {
                        const attribute = _.findWhere(dropdownOpts?.asset_attributes_type, { attribute_type_id: item?.attribute_type_id });
                        if (!_.isEmpty(attribute)) {
                            savedColumns.push(attribute);
                        }
                    })
                    return { ...child, "saved_columns": savedColumns }
                })
                setConfig((prev) => ({ ...prev, api_data: children, data: children, loader: false, is_change: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setConfig((prev) => ({ ...prev, loader: false }));
        }
    }

    const saveAssetConfiguration = async (row, selected) => {
        try {
            const payload = {
                "asset_type_id": row?.asset_type_id,
                "attribute_type_id": _.pluck(selected ? selected : row?.saved_columns, "attribute_type_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTASSETCONFIGURATION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getAssetConfiguration();
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const restoreScroll = () => {
        const interval = setInterval(() => {
            const viewport = document.querySelector('.ag-body-viewport');
            if (viewport) {
                viewport.scrollTop = scrollTop;
                clearInterval(interval);
            }
        }, 30);
    };

    const attachScrollListener = () => {
        const viewport = document.querySelector('.ag-body-viewport');
        if (!viewport) return;

        viewport.addEventListener('scroll', () => {
            setScrollTop(viewport.scrollTop);
        });
    };

    const handleExcelUpload = (e) => {
        const file = e.target?.files?.[0];
        if (!file) {
            showInfo("Info", "Please select a file.");
            setImportExcel((prev) => ({ ...prev, data: [] }));
            return;
        }

        // Validate file type
        const allowedExtensions = /(\.xlsx|\.xls)$/i;
        if (!allowedExtensions.exec(file.name)) {
            showInfo("Info", "Invalid file type. Please upload an Excel file.");
            e.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
                handleImportExcelValidations(jsonData);
            } catch (error) {
                console.error("Error reading Excel file:", error);
                showInfo("Info", "Error reading file. Please check the format.");
            }
        };
        reader.readAsBinaryString(file);
    };

    const handleImportExcelValidations = (data) => {
        let payloadArray = [];
        let errors = {};
        try {
            data?.forEach((item) => {
                const headers = Object?.keys(item);
                // create asset payload
                let obj = {
                    asset_id: 0,
                    asset_unique_id: "",
                    machine_host_name: "",
                    finance_unique_id: "",
                    asset_type_id: 0,
                    asset_make_id: 0,
                    model_number: "",
                    serial_number: "",
                    purchase_date: "",
                    warranty_end_date: "",
                    life_in_months: 0,
                    vendor_id: 0,
                    invoice_number: "",
                    purchase_price: 0,
                    branch_id: 0,
                    status_id: 0,
                    is_discontinue: false,
                    discontinued_date: "",
                    remark: "",
                    attribute_type_unit_mapping: [],
                    assets_original_media: [],
                    business_unit: "",
                    sub_business_unit: "",
                    insured_by: "",
                    chargeback_to: "",
                    is_rental: filterValues?.purchase_type?.flag
                }
                let tempObj = {};
                headers?.forEach(head => {
                    const field = _.filter(columnDef, (i) => { return i?.headerName?.trim()?.toLowerCase() === head?.trim()?.toLowerCase() })?.[0]?.field || "";
                    if (obj[field] !== undefined) {
                        // handle validation for unique fields
                        if (field === "asset_unique_id" || field === "machine_host_name" || field === "finance_unique_id") {
                            if (validateUniqueId(field, item?.[head])) {
                                errors = { ...errors, [item[head]]: `This ${field?.split("_")?.join(" ")} already exists` }
                            }
                        }

                        // set payload values for matched field
                        obj[field] = (item?.[head] === "NA" || item?.[head] === "Stock") ? "" : (field?.includes("_date") ? dateConvert(item?.[head]?.split("-")?.reverse()?.join("-"), "iso-string") : item?.[head])
                    } else if (field) {
                        // set unmatched field in temp obj
                        tempObj[field] = item?.[head]
                    } else {
                        errors = { ...errors, [head]: "Header not found" };
                    }
                })

                !_.isEmpty(obj) && Object?.keys(obj)?.forEach(key => {
                    // find and set values for dropdown fields
                    if (key?.includes("_id") && obj?.[key] === 0 && key !== "asset_id") {
                        let findData = {};
                        if (tempObj?.[key?.replace("_id", "_name")]) {
                            findData = _.findWhere(dropdownOpts?.[key?.split("_id")?.[0]], { [key?.replace("_id", "_name")]: tempObj?.[key?.replace("_id", "_name")] });
                        } else if (obj?.[key?.replace("_id", "_name")]) {
                            findData = _.findWhere(dropdownOpts?.[key?.split("_id")?.[0]], { [key?.replace("_id", "_name")]: obj?.[key?.replace("_id", "_name")] });
                        }
                        if (!_.isEmpty(findData)) {
                            obj[key] = findData?.[key];
                            tempObj?.[key?.replace("_id", "_name")] && delete tempObj?.[key?.replace("_id", "_name")];
                        } else {
                            errors = { ...errors, [tempObj?.[key?.replace("_id", "_name")] || obj?.[key?.replace("_id", "_name")]]: `Could not find this value in ${key?.split("_id")?.[0]?.split("_")?.map(item => item?.charAt(0)?.toUpperCase() + item?.slice(1))?.join(" ")} dropdown` }
                        }
                    }
                })

                // set payload values for dynamic attribute fields
                config?.currentConfig?.forEach((att) => {
                    if (item?.[att?.attribute_type_name] !== "NA") {
                        let allowInsert = false;
                        if (att?.attribute_type_key === "cpu_in_gen_ghz" || att?.attribute_type_key === "os" || att?.attribute_type_key === "ssid") {
                            const findOpt = _.findWhere(dropdownOpts?.[att?.attribute_type_key], { [`${att?.attribute_type_key === "ssid" ? "asset_ssid" : att?.attribute_type_key}_name`]: item?.[att?.attribute_type_name] })
                            if (_.isEmpty(findOpt)) {
                                allowInsert = true;
                            }
                        }
                        const attrObj = {
                            attribute_type_id: att?.attribute_type_id,
                            attribute_unit_id: 0,
                            attribute_unit_name: item?.[att?.attribute_type_name],
                            is_enable_insert: allowInsert
                        }
                        obj.attribute_type_unit_mapping.push(attrObj);
                    }
                })
                payloadArray.push(obj);
            })
        } catch (err) {
            showInfo("Info", err);
        }
        let columns = [];
        Object.keys(data?.[0])?.forEach(item => {
            columns.push({
                label: item,
                key: item,
                headerRender: () => <div title={errors?.[item]}>{item}</div>,
                style: { width: "150px", textAlign: "center", padding: 0, cursor: "default" },
                headerStyle: { textAlign: "center", backgroundColor: Object.keys(errors)?.includes(item) ? "#e5e5e5" : "#f5f5f5" },
                render: (row) => <div className="text-truncate py-1" style={{ backgroundColor: Object.keys(errors)?.includes(row?.[item]) ? "#ffd3d3" : (Object.keys(errors)?.includes(item) ? "#e5e5e5" : "") }} title={errors?.[row?.[item]] || errors?.[item]}>
                    {row?.[item] ? (String(row?.[item])?.toLowerCase()?.trim() === "na" ? "-" : row?.[item]) : "-"}
                </div>
            })
        })
        setColumns(columns);
        setImportExcel((prev) => ({ ...prev, data }));
        if (!_.isEmpty(errors)) {
            showInfo("Info", "There is some mismatch in the highlighted cells");
            return;
        } else {
            !_.isEmpty(payloadArray) && saveImportExcelData(payloadArray);
        }
    }

    const saveImportExcelData = async (payloadArray) => {
        try {
            const payload = {
                asset_json: JSON.stringify(payloadArray) || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEIMPORTASSETEXCELDATA"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setImportExcel((prev) => ({ ...prev, visible: false, data: [] }));
                getInventoryDetails();
                handleAssetDetails();
            } else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleColumnChange = (val, rowdata, callApi) => {
        let data = [...config?.data];
        data?.map(item => {
            if (item?.asset_type_id === rowdata?.asset_type_id) {
                item["saved_columns"] = val;
            }
        })
        setConfig((prev) => ({ ...prev, data, is_change: true }));
        callApi && saveAssetConfiguration(rowdata, val)
    }

    // set default columns including dynamic columns
    const setDefaultDynamicCols = (current) => {
        let dynCols = [...basicColDef];
        let idx = 19;
        (current ? [...current] : [...config?.currentConfig])?.forEach(item => {
            const obj = {
                field: item?.attribute_type_key,
                optionalField: item?.attribute_type_key?.includes("ssid") ? "asset_ssid" : `${item?.attribute_type_key}_name`,
                headerName: item?.attribute_type_name,
                cellStyle: { textAlign: "center", alignContent: "center" },
                cellRenderer: (params) => {
                    const value = _.findWhere(params?.data?.attributes, { attribute_type_id: item?.attribute_type_id })
                    return (
                        <div title={value?.attribute_unit_name} className="w100 text-truncate">{value?.attribute_unit_name}</div>
                    )
                }
            }
            dynCols.splice(idx, 0, obj);
            idx++;
        })
        const dynamic = dynCols?.map((item, index) => { return { ...item, display_order: index } });
        setDefaultDynColDef(dynamic);
    }

    // Restore after assign/receive/create asset
    const handleAssetDetails = () => {
        sessionStorage.removeItem("cpu_in_gen_ghz");
        sessionStorage.removeItem("ssid");
        sessionStorage.removeItem("os");
        sessionStorage.removeItem("assets_details");
        callautopopulate("assets_details", "cpu_in_gen_ghz", "ssid", "os").then((res) => {
            setDropdownOpts((prev) => ({
                ...prev,
                cpu_in_gen_ghz: res?.cpu_in_gen_ghz,
                ssid: res?.ssid,
                os: res?.os,
                assets_details: res?.assets_details,
            }));
        })
    }

    const handleStickerData = (rowdata) => {
        if (rowdata?.is_currently_assigned) {
            let data = {
                first: [
                    { label: "Employee Name", value: rowdata?.is_currently_assigned?.user_display_name },
                    { label: "Employee ID", value: rowdata?.is_currently_assigned?.employee_id },
                    { label: "Machine S/N", value: rowdata?.serial_number },
                    { label: "Machine Name", value: rowdata?.machine_host_name },
                    { label: "OS", value: rowdata?.os_name, hide: _.isEmpty(_.findWhere(config?.currentConfig, { attribute_type_key: "os" })) },
                    { label: "SSID", value: rowdata?.asset_ssid_name, hide: _.isEmpty(_.findWhere(config?.currentConfig, { attribute_type_key: "ssid" })) },
                    { label: "Service Tag", value: rowdata?.["Service Tag"], hide: _.isEmpty(_.findWhere(config?.currentConfig, { attribute_type_key: "service_tag" })) },
                    { label: "Finance ID", value: rowdata?.finance_unique_id },
                    { label: "Type", value: rowdata?.asset_type_name },
                ],
                second: [
                    { label: "Employee Name", value: rowdata?.is_currently_assigned?.user_display_name },
                    { label: "Employee ID", value: rowdata?.is_currently_assigned?.employee_id },
                    { label: "Machine Name", value: rowdata?.machine_host_name },
                ]
            };
            let barcode = {};
            data?.first?.forEach(item => {
                barcode = { ...barcode, [item?.label]: item?.value || " " }
            })
            setStickerData((prev) => ({ ...prev, data: data, barcode_data: barcode }));
        }
    }

    const reactToPrintFn = useReactToPrint({
        contentRef,
        documentTitle: "Asset sticker",
        onAfterPrint: () => {
            setStickerData((prev) => ({ ...prev, data: null, barcode_data: null }));
        }
    });

    return useMemo(() => ({
        dropdownOpts, filterValues, setFilterValues, onFilterTextBoxChanged, isChange, setIsChange, rowData, columnDef, display, setDisplay, gridRef, editData, setEditData, popupData, getInventoryDetails, loader, tagRef, handleExcelDownload, orderColumnDef, orderRowData, search, attachScrollListener, pagination, setPagination, handleExcelUpload, importExcel, setImportExcel, config, setConfig, configCols, handleAssetDetails, stickerData, contentRef, columns
    }), [dropdownOpts, filterValues, setFilterValues, onFilterTextBoxChanged, isChange, setIsChange, rowData, columnDef, display, setDisplay, gridRef, editData, setEditData, popupData, getInventoryDetails, loader, tagRef, handleExcelDownload, orderColumnDef, orderRowData, search, attachScrollListener, pagination, setPagination, handleExcelUpload, importExcel, setImportExcel, config, setConfig, configCols, handleAssetDetails, stickerData, contentRef, columns])
}